var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCache = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 55",
    style: {
      enableBackground: "new 0 0 55 55"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#2559E1;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.5,
    cy: 27.5,
    r: 26.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.5,3.2c13.4,0,24.3,10.9,24.3,24.3S40.9,51.8,27.5,51.8S3.2,40.9,3.2,27.5S14.1,3.2,27.5,3.2 M27.5,1.2 C13,1.2,1.2,13,1.2,27.5S13,53.8,27.5,53.8S53.8,42,53.8,27.5S42,1.2,27.5,1.2L27.5,1.2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M40.8,25.7c0-1.5-0.5-2.3-1-2.9c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1c0-2.6-1.2-4.5-2.6-4.5 c-1.5,0-2.6,1.9-2.6,4.6c-0.1,0.1-0.2,0.3-0.2,0.4c-0.4,0.6-0.9,1.4-1,2.8h-1.7c0-1.4-0.5-2.1-1-2.8c-0.1-0.1-0.2-0.3-0.2-0.4 c0,0,0-0.1,0-0.1c0-2.6-1.2-4.5-2.6-4.5c-1.5,0-2.6,1.9-2.6,4.6c-0.1,0.1-0.2,0.3-0.2,0.4c-0.4,0.6-0.9,1.4-1,2.8h-1.7 c0-1.4-0.5-2.1-1-2.8c-0.1-0.1-0.2-0.3-0.2-0.4c0,0,0-0.1,0-0.1c0-2.6-1.1-4.5-2.6-4.5c-1.5,0-2.6,1.9-2.7,4.6 c-0.1,0.1-0.2,0.3-0.2,0.4c-0.4,0.6-0.9,1.4-1,2.9v0V35v1.5c0,0.4,0.3,0.6,0.6,0.6h6.4c0.3,0,0.6-0.3,0.6-0.7v-1.5v-3.1h1.7v3.1v1.5 c0,0.4,0.3,0.7,0.6,0.7h6.4c0.3,0,0.6-0.3,0.6-0.7v-1.5v-3.1h1.7v3.1v1.5c0,0.4,0.3,0.7,0.6,0.7h6.4c0.3,0,0.6-0.3,0.6-0.7v-1.5 V25.7z M23.7,30.6h-1.7v-3.6h1.7V30.6z M33.1,30.6h-1.7v-3.6h1.7V30.6z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCache);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cache.2f38bbc771bdc034c865df3ed0396198.svg";